import React from 'react';

export const Info1 = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <path
      fillRule="evenodd"
      d="M20 11.53c-4.67 0-8.47 3.8-8.47 8.47 0 4.67 3.8 8.47 8.47 8.47 4.67 0 8.47-3.8 8.47-8.47 0-4.67-3.8-8.47-8.47-8.47zm1.876 12.906c-.466.183-2.084.956-3.015.135-.278-.245-.417-.555-.417-.93 0-.705.232-1.32.649-2.794.073-.279.163-.64.163-.927 0-.495-.188-.626-.697-.626-.248 0-.523.088-.773.182l.138-.564c.556-.226 1.253-.502 1.85-.502.896 0 1.555.447 1.555 1.297 0 .245-.042.674-.131.97l-.515 1.823c-.107.369-.3 1.181-.001 1.422.294.238.989.111 1.332-.05l-.138.564zm-.851-7.26c-.585 0-1.059-.474-1.059-1.058 0-.585.474-1.06 1.059-1.06.584 0 1.059.475 1.059 1.06 0 .584-.475 1.058-1.06 1.058z"
    />
  </svg>
);
